<template>
  <v-app>
    <main-app-bar elevation="2" app-bar-color="" app-bar-text-color="">
    </main-app-bar>
    <v-main class="mainDiv playFairFont" v-bind:style="{ 'background-image': 'url(' + baseImg + ')' }">
      <div style="position: absolute; top: 65px; left: 0; right: 0; bottom: 10px; overflow-y: scroll">
        <v-container fluid>
          <v-row v-if="state === 'CATEGORY'" class="mt-0 mx-auto" align="center" justify="center" style="width: 70%">
            <v-col v-for="(item, index) in galleryItems" :key="index" lg="3" sm="12" xs="12">
              <v-card class="mx-auto" max-width="300" hover link
                      @click="onGalleryItemClick(item.title,item.categoryFolderName, item.pictureCount)">
                <img
                    style="object-fit: scale-down"
                    color="surface-variant"
                    class="mx-auto px-auto d-flex justify-center"
                    height="300"
                    width="200"
                    :src=item.img
                />

                <v-card-title>
                  <div class="font-weight-bold ms-1 mb-2">{{ item.title }}</div>
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="state === 'PICTURES'" >
            <v-col lg="2" xs="12">
              <v-btn
                  prepend-icon="mdi-arrow-left"
                  variant="text"
                  @click="onBackClick"
              >
                Vissza a galériához
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-if="state === 'PICTURES'" class="mt-0 mx-auto" align="center" justify="center" style="width: 70%">
            <v-col v-for="(picture, index) in selectedPictures" :key="index" lg="3"  >
              <v-card class="mx-auto" max-width="300" hover link
                      @click="onPictureItemClick(picture, index)">
                <img
                    style="object-fit: scale-down"
                    color="surface-variant"
                    class="mx-auto px-auto d-flex justify-center"
                    height="300"
                    width="200"
                    :src=picture
                />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <v-dialog v-model="pictureDialog" >
        <v-toolbar style="background-color: #ffffff00">
          <v-spacer></v-spacer>
          <v-btn icon @click="pictureDialog = false" style="color: ivory">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
          <v-carousel hide-delimiters v-model="selectedSlide">
            <v-carousel-item
                v-for="(item,i) in selectedPictures"
                :key="i"
                :src="item"
                reverse-transition="fade-transition"
                transition="fade-transition"
            ></v-carousel-item>
          </v-carousel>
      </v-dialog>
    </v-main>

  </v-app>
</template>

<script lang="ts">

import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import {getAxios} from "@/AxoisFactory"

@Options({
  components: {MainAppBar},
  data() {
    return {
      state: "CATEGORY",
      selectedPictures: [],
      selectedCategory: "Kategóriák",
      baseImg: require("@/assets/base.png"),
      pictureDialog: false,
      selectedSlide: 0,
      galleryItems: [
        {
          title: "Céges ruházat",
          img: require("@/assets/jacket.png"),
          categoryFolderName: "workclothes",
          pictureCount: 10
        },
      ]
    };
  },
  created() {
    const axios = getAxios();
    console.log("mounted gallery")
    axios.get("/gallery/categories").then((r: any) => {
      console.log(r);
      this.galleryItems = r.data
    })
  },
  computed: {
    getPictureCategories() {
      return this.$store.getters.getPictureCategories
    }
  },
  watch: {
    getPictureCategories(categories) {
      this.galleryItems = categories;
    }
  },
  methods: {
    onGalleryItemClick(title: string, preFix: string, count: number) {

      this.selectedCategory = title;
      console.log(preFix, count);
      this.selectedPictures = [];
      for (let i = 0; i < count ; i++) {
        this.selectedPictures.push(
            `./gallery/${preFix}/picture/${i}`
        )
      }
      this.state = "PICTURES"
    },
    onPictureItemClick(picture: string, selectedPicture: number) {
      this.selectedSlide = selectedPicture;
      this.pictureDialog = true;
      console.log(picture);
    },
    onBackClick() {
      this.state = "CATEGORY";
    }
  }
})
export default class Galery extends Vue {
}
</script>

<style scoped>
.mainDiv {
  background-repeat: no-repeat;
  /*background-attachment: fixed;*/
  background-size: cover;
  background-position: 100% 100%;
}
</style>